import { LegalDoc } from "@/components/LegalDoc";

export default function Privacidad() {
  return <LegalDoc endpoint="/public/privacidad" slug="privacidad" footerLabel="Política de Privacidad"
    related={{ to: "/terminos", label: "Ver Términos y Condiciones" }} />;
}
